import { render, staticRenderFns } from "./KDivider.vue?vue&type=template&id=2dbe0cdc&"
import script from "./KDivider.vue?vue&type=script&lang=js&"
export * from "./KDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports